import { BALANCE_EASE } from "../AnimatedNumber";

export const SWAP = {
  initial: { opacity: 0, y: 6 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -6 },
  transition: { duration: 0.16, ease: BALANCE_EASE },
} as const;